const getters = {
  token: state => state.user.token,
  userInfo: state => state.user.userInfo,
  sidebarItem:state => state.user.sidebarItem,
  tags: state => state.tagsView.tags,
}
export default getters
